import { render } from "./galeryProduct.vue?vue&type=template&id=5c129288"
import script from "./galeryProduct.vue?vue&type=script&lang=js"
export * from "./galeryProduct.vue?vue&type=script&lang=js"

import "./galeryProduct.vue?vue&type=style&index=0&id=5c129288&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__